<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-alert
          prominent
          icon="mdi-alert-circle-outline"
          outlined
          border="bottom"
          type="error">
          <h3 class="text-h5"> {{ $t('unsupported.title') }} </h3>
          <div>
            {{ $t('unsupported.note') }}
          </div>
            {{ $t('unsupported.help') }}
        </v-alert>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'view-unsupported'
}
</script>

<style scoped>
</style>
